import { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from './Layout';
import Home from './pages/Home';
import CreateGame from './pages/dashboard/CreateGame';
import InviteGame from './pages/InviteGame';
import PlayGame from './pages/PlayGame';
import Error from './pages/Error';

function App() {
  const [adminData, setAdminData] = useState({id: '', name: '', email: ''});
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout adminData={adminData} setAdminData={setAdminData} />}>
          <Route path="/" element={<Home adminData={adminData} setAdminData={setAdminData} />} />
          <Route caseSensitive={true} path="/dashboard/create-game" element={<CreateGame adminData={adminData} setAdminData={setAdminData} />} />
        </Route>
        <Route path="/invite-game/:channelId" element={<InviteGame />} />
        <Route path="/play-game/:channelId" element={<PlayGame />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
